<template>
<div>
	<div class="classBox">
		<div class="classChocie">
			<el-input placeholder="请输入检索关键词" v-model="searchByText" @keyup.enter.native="getSupplierGoodsFn">
				<i slot="suffix" class="el-input__icon el-icon-search"></i></el-input>
			<el-radio-group v-model="searchByType" @input="getSupplierGoodsFn">
				<el-radio-button v-for="item in typeOptions" :label="item.value">
					{{ item.label }}</el-radio-button>
			</el-radio-group>
			<el-button type="text" @click.stop="btnClick(1)" class="classBtn"
				:class="{ 'btnActive': type === 1 }" style="margin-left: auto;">销量
				<i class="el-icon-d-caret" v-show="orderTypeSale === 0"></i>
				<i class="el-icon-caret-top" v-show="orderTypeSale === 1"></i>
				<i class="el-icon-caret-bottom" v-show="orderTypeSale === 2"></i>
			</el-button>
			<el-button type="text" @click.stop="btnClick(2)" :class="{ 'btnActive': type === 2 }" class="classBtn">
				上架时间
				<i class="el-icon-d-caret" v-show="orderTypeTime === 0"></i>
				<i class="el-icon-caret-top" v-show="orderTypeTime === 1"></i>
				<i class="el-icon-caret-bottom" v-show="orderTypeTime === 2"></i>
			</el-button>
			<el-button type="text" @click.stop="btnClick(3)" :class="{ 'btnActive': type === 3 }" class="classBtn">
				价格
				<i class="el-icon-d-caret" v-show="orderTypePrice === 0"></i>
				<i class="el-icon-caret-top" v-show="orderTypePrice === 1"></i>
				<i class="el-icon-caret-bottom" v-show="orderTypePrice === 2"></i>
			</el-button>
			<span>
				排列：
				<i class="el-icon-menu m-r-10" @click="sortType = 1"
					:style="`color: ${sortType === 1 ? '#2569F2': ''}`"></i>
				<i class="el-icon-s-grid" @click="sortType = 2"
					:style="`color: ${sortType === 2 ? '#2569F2': ''}`"></i>
			</span>
		</div>
	</div>

	<div class="companyProductList" :class="{ 'companyProductList_sort': sortType === 2 }">
		<div :style="[{ 'width': (sortType === 2 ? '50%' : '100%') }, { 'padding-right': (sortType === 2 ? '20px' : '0px') }]"
			class="companyProductListItemBox" v-for="(item, index) in tableData" :key="index">
			<el-image class="companyProductListItemBox_Img" :src="item.goodsThumbnail" fit="cover"
				:preview-src-list="item.goodsThumbnail ? [item.goodsThumbnail] : []"></el-image>
			<div class="companyProductListItemBox_Right"
				:class="{ 'companyProductListItemBox_Right_sort': sortType === 2, 'companyProductListItemBox_Right_sortNot': sortType !== 2 }">
				<div class="companyProductListItemBox_TitleBox">
					<div class="titleBox_title of-1" @click="toDetail(item)">
						{{ item.goodsName || '--' }}</div>
					<el-divider></el-divider>
				</div>
				<div class="companyProductListItemBox_TitleBoxInfo of-3" v-if="item.goodsCategory!=1"
					:class="[sortType === 2 ? 'font-14 m-b-10' : 'font-18 m-b-20']"
					:style="`-webkit-line-clamp: ${sortType === 2 ? '2' : '3'};`">
					{{ item.goodsDescribe || '--' }}
				</div>
				<div class="image-item-info-bottom" v-if="item.goodsCategory === 1">
					<el-tag v-if="item.productDistinguishability">{{ item.productDistinguishability }}m</el-tag>
					<el-tag v-if="item.productSpectralCoverage" style="margin-left: 10px;">{{ item.productSpectralCoverage }}</el-tag>

					<!-- <div>{{ item.productSpectralCoverage }}</div> -->
				</div>
				<div class="companu-product-item-price">
					￥{{ productPrice(item.goodsPriceType, item.goodsPrice) }}</div>
				<div class="companyProductListItemBox_Set flex-be" :style="[{ 'flex-wrap': (sortType === 2 ? 'wrap' : '') }]">
					<div class="of-1 flex-cen font-14" v-if="!item.t" :class="{'w-100': sortType === 2}">
						<i class="el-icon-s-shop icon_box"></i>
						<span>{{ item.shopName || '--' }}</span>
					</div>
					<div class="of-1 flex-cen font-14">
						<i class="el-icon-s-marketing icon_box"></i>
						<span>销售: {{ item.saleNum || 0 }}</span>
					</div>
					<div class="of-1 flex-cen font-14">
						<i class="el-icon-view icon_box"></i>
						<span>浏览: {{ item.readNum || 0 }}次</span>
					</div>
					<div class="company-product-item-operate"
						:class="{ 'w-100': sortType === 2, 'm-t-10': sortType === 2 }">
						<el-button type="primary" @click="goPay(item)">立即购买
							<i class="el-icon-check"></i></el-button>
						<el-button type="primary" plain @click="addCart(item)">加入购物车
							<i class="el-icon-plus"></i></el-button>
					</div>
				</div>
			</div>
		</div>
		<el-empty v-if="tableData.length <= 0" description="暂无数据"></el-empty>

		<div class="w-100 m-t-50 m-b-30">
			<el-pagination @current-change="getSupplierGoodsFn" background
				:current-page.sync="current" layout="total, prev, pager, next, jumper"
				:total="total"></el-pagination>
		</div>
	</div>
</div>
</template>

<script>
export default {
	components: {},
	props: ['shopId'],
	data() {
		return {
			type: 1,
			orderTypeSale: 0,
			orderTypeTime: 0,
			orderTypePrice: 0,
			dataImg: require("@/assets/imgs/RemoteSensingMall/dataImg.png"),
			tableData: [],
			current: 1, // 当前页码
			total: 10, // 数据总条数
			sortType: 1,

			searchByText: null, // 商品名搜索
			searchByType: '', //商品类型搜索
			typeOptions: [
				{label: '全部', value: ''},
				{label: '影像数据', value: '1'},
				{label: '数据产品', value: '2'},
				{label: '软件产品', value: '3'},
				{label: '其他产品', value: '4'},
				// {label: '解决方案', value: '5'},
			],

		};
	},
	mounted() {
		this.getSupplierGoodsFn();
	},
	computed: {
		productPrice() {
            return (type, price) => {
                if(type === 2) return '面议';
                else if(type === 3) return '免费';
                else return Number(price).toFixed(2)
            }
        }
	},
	methods: {
		async getSupplierGoodsFn() {
			console.log(this.shopId)
			try {
				let params = {
					shopId: this.shopId,
					goodsCategory: this.searchByType,
					orderType: this.type === 1 ? this.orderTypeSale : this.type === 2 ? this.orderTypeTime : this.orderTypePrice,
					type: this.type,
					pageNum: this.current,
					pageSize: 10,
					keyword: this.searchByText
				};
				// getSupplierGoods
				let res = await this.$http.post(this.$const.RemoteSensingMall.requestShopAllProduct, params);
				if (res && res.data && res.code === 200) {
					console.log(res);
					this.tableData = res.data.list;
					this.total = res.data.total;
				}
			} catch (e) {
				// console.log(e);
			}
		},
		btnClick(type) {
			this.type = type;
			if (type === 1) {
				this.orderTypeSale = this.orderTypeSale === 1 ? 2 : 1;
				this.orderTypeTime = 0;
				this.orderTypePrice = 0;
			}
			if (type === 2) {
				this.orderTypeTime = this.orderTypeTime === 1 ? 2 : 1;
				this.orderTypePrice = 0;
				this.orderTypeSale = 0;
			}
			if (type === 3) {
				this.orderTypePrice = this.orderTypePrice === 1 ? 2 : 1;
				this.orderTypeTime = 0;
				this.orderTypeSale = 0;
			}
			this.current = 1;
			this.getSupplierGoodsFn();
		},
		toDetail(data) {
			if(data.goodsCategory==1){
				this.$router.push({ name: "shopDetail", query: { goodsId: data.goodsId}})
			}else{
				this.$router.push({ name: "productDetail", params: { id: data.goodsId}})
			}
		},
		async goPay(data) {
			if(this.isLogin()) {
				let params = {
					buyType: 1,
					itemParams: [{ "goodsId": data.goodsId, "number": 1 }]
				};
				try {
					let res = await this.$http.post(this.$const.RemoteSensingMall.shoppingCartAddOrder, params);
					if (res && res.code === 200 && res.data) {
						this.$router.push({
							path: "/confirmPay",
							query: { N: res.data }
						});
					}
				} catch (e) {
					// console.log(e);
				}
			}
		},
		addCart(product) {
			console.log(product.goodsId)
			if(this.isLogin()) {
				this.$http.post(this.$const.RemoteSensingMall.shoppingCartaddItem, [{
					goodsId: product.goodsId,
					number: 1
				}]).then(res => {
					if(res.code === 200 && res.data == "添加成功") {
						this.$store.dispatch("shoppingCart/getCartINFO", {})
						this.$message.success(this.$PubText.joinBuyCarSuccess)
					}else {
						this.$message.error(this.$PubText.joinBuyCarFail)
					}
				}).catch(error => {
					console.log(error)
					this.$message.error(this.$PubText.InterfaceFail)
				})
			}
		},
		isLogin() {
			if(this.$store.state.user.userInfo.id) {
				return true
			}else {
				this.$message.warning('请先登录');
				return false
			}
		},
	}
};
</script>

<style lang="scss" scoped>
.classBox {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 20px;
	background-color: white;

	> .classChocie {
		display: flex;
		align-items: center;
		width: 100%;

		> .el-input {
			width: 300px;
			> ::v-deep .el-input__inner {
				background-color: #F5F5F5;
			}
		}
		> .el-radio-group {
			margin-left: 40px;
			white-space: nowrap;
		}

		> .classBtn {
			padding: 5px 10px;
			
			color: #2569F2;
			font-size: 14px;
			white-space: nowrap;

			&.btnActive {
				background-color: rgba($color: #2569F2, $alpha: .15);
				border: 1px solid #2569F2;
				border-radius: 2px;
			}

			> i {
				cursor: pointer;
			}
		}

		> span {
			display: inline-block;
			margin-left: 16px;
			padding-bottom: 3px;
			font-size: 14px;
			font-weight: 600;

			> i {
				cursor: pointer;
			}
		}
	}
}

.companyProductList {
	padding: 20px 0;

	&.companyProductList_sort {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}

	> .companyProductListItemBox {
		flex-wrap: nowrap;
		display: flex;
		align-items: center;
		padding: 30px;
		background-color: white;
		border-bottom: 1px solid #EEEEEE;

		.companyProductListItemBox_Img {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 240px;
			height: 240px;
			margin-right: 30px;
			border-radius: 6px;
			cursor: pointer;
		}
		> .companyProductListItemBox_Right {

			&.companyProductListItemBox_Right_sort {
				width: calc(100% - 290px);
			}
			&.companyProductListItemBox_Right_sortNot {
				width: calc(100% - 290px);
			}
			> .companyProductListItemBox_TitleBox {
				font-size: 20px;
				margin-bottom: 10px;

				> .titleBox_title {
					width: 88%;
					margin-right: 20px;
					font-size: 24px;
					font-weight: 700;
					cursor: pointer;

					&:hover {
						color: #2469f1;
					}
				}
				> .el-divider {
					width: 50px;
					height: 2px;
					margin: 20px 0;
					background-color: #2569F2;
				}
			}
			> .companyProductListItemBox_Set {
				display: flex;
				align-items: flex-end;

				.icon_box {
					color: #000;
					margin-right: 10px
				}
				> .company-product-item-operate {

					> button {

						i {
							margin-left: 20px;
						}
					}
				}
			}
			> .companyProductListItemBox_TitleBoxInfo {
				color: #333333;
				text-overflow: ellipsis;
				overflow: hidden;
			}
			> .companu-product-item-price {
				color: #B11A1A;
				font-size: 28px;
				font-weight: 600;
			}
		}
	}
}
.image-item-info-bottom {
			display: flex;
			align-items: center;
			// justify-content: space-between;
			margin-top: 6px;

			span {
				height: initial;
				padding: 3px 10px;
				line-height: initial;
			}

			div {
				color: #999;
				font-size: 14px;
				margin-left: 10px;
			}
		}
</style>